import React, { useState } from 'react'
import { ProjectConfig } from '@/project-config'
import icPhoneActive from '../../assets/login/phone-active.svg'
import icCodeActive from '../../assets/login/code-active.svg'
import icPsdActive from '../../assets/login/psd-active.svg'
import LoginLeft from '../login/components/login-left'
import LoginRight from '../login/components/login-right'
import lessModule from './index.module.less'

const preloadImg = (src: string) => {
  const img = new Image()
  img.src = src
}
preloadImg(icPhoneActive)
preloadImg(icCodeActive)
preloadImg(icPsdActive)

export default function SuzhouLogin() {
  const [resettingPassword, setResettingPassword] = useState(false)
  return (
    <div className={`${lessModule.login} ${resettingPassword ? lessModule.resettingPassword : 'login-custom-form'}`} id="login-form-override">
      <div className={lessModule.loginLeft}>
        <LoginLeft hideProductName onResetPasswordChange={setResettingPassword} />
      </div>
      {!resettingPassword && <LoginRight disableAnimation titleText={ProjectConfig.loginRight.titleText} />}
    </div>
  )
}
